"use client";

import { useWindowSize } from "@/hooks/useWindowSize";
import Image from "next/image";
import React from "react";
import dynamic from "next/dynamic";
const ZoomInWrapper = dynamic(() => import("../motion/ZoomInWrapper"));

const JoinSection = () => {
  const { width } = useWindowSize();
  let mobile = width < 1024;
  return (
    // <section className="bg-orange-600 pb-20 px-4 bg-[url('/assets/orange_lite_bg.svg')] bg-cover bg-center">
    //   <div className="flex flex-col item-center justify-center mx-auto text-center max-w-full xs:max-w-8/10">
    //     <div className="flex flex-col items-center">
    //       <Image
    //         src="/assets/joinPage/Frame_9A.svg"
    //         alt="Start Icon"
    //         width={700}
    //         height={20}
    //       />
    //     </div>
    //     <div className="flex justify-center my-6">
    //       <div className="bg-blue-600 text-white text-center py-1 px-10 rounded-xs inline-block mb-6 font-bold text-sm max-w-fit">
    //         Your key to SSC Selection
    //       </div>
    //     </div>
    //     <ZoomInWrapper>
    //       <div className="text-4xl sm:text-5xl font-extrabold text-white mb-6">
    //         Create your Personal
    //       </div>
    //     </ZoomInWrapper>
    //     <ZoomInWrapper delay={0.2}>
    //       <div className="text-4xl sm:text-5xl font-extrabold text-white">
    //         Revisions Today
    //       </div>
    //     </ZoomInWrapper>
    //     <ZoomInWrapper delay={0.4}>
    //       <div id="downloadApp" className="flex flex-col items-center mt-10">
    //         <div className="flex justify-center mt-15 mb-1">
    //           <div className="bg-white text-orange-600 text-center px-10 py-1 rounded-sm inline-block mb-1 font-bold text-md max-w-fit">
    //             Join for Free
    //           </div>
    //         </div>
    //         <a
    //           target="_blank"
    //           href="https://play.google.com/store/apps/details?id=app.netpractice.app&pcampaignid=web_share"
    //           aria-label="app" className="btn" title="app"
    //         >
    //           <button className="cursor-pointer flex items-center bg-gray-700 py-3 px-6 rounded-full shadow-lg hover:shadow-xl hover:bg-grey-600 transition-all duration-300 relative border-b-4 border-grey-700">
    //             <Image
    //               src="/playStore.svg"
    //               alt="Start Icon"
    //               width={30}
    //               height={30}
    //               className="mr-3"
    //             />
    //             <div className="flex flex-col items-start">
    //               <div className="text-white text-sm sm:text-lg font-bold">
    //                 Download Android App
    //               </div>
    //               <div className="text-[11px] text-neutral-300">
    //                 available on PlayStore
    //               </div>
    //             </div>
    //           </button>
    //         </a>
    //       </div>
    //     </ZoomInWrapper>
    //   </div>
    // </section>
    <section
      className={`flex px-auto bg-white bg-center ${
        mobile ? "h-fit" : "min-h-fit"
      } bg-no-repeat `}
    >
      {mobile ? (
        <div className="flex item-center justify-end m-10 min-h-[100vw]  text-center w-full h-full bg-[url('/assets/joinPage/Frame_9B_mobile.png')] bg-contain  bg-no-repeat  bg-center ">
          <div className="z-10 mx-auto h-fit w-[60%]  md:w-1/2 text-left flex flex-col justify-center mt-[8%]">
            <ZoomInWrapper>
              <div
                className={`${
                  width < 375 ? "text-md" : "text-lg"
                } xs:text-xl sm:text-2xl md:text-4xl font-extrabold  mb-1`}
              >
                Create your <span className="text-orange-500"> Personal </span>
              </div>
            </ZoomInWrapper>
            <ZoomInWrapper delay={0.2}>
              <div
                className={`${
                  width < 375 ? "text-md" : "text-lg"
                } xs:text-xl sm:text-2xl md:text-4xl font-extrabold mb-1 sm:mb-5 `}
              >
                <span className="text-orange-500"> Revisions </span> Today
              </div>
            </ZoomInWrapper>
            <ZoomInWrapper
              delay={0.3}
              className={`${width < 380 ? "hidden" : "block"}`}
            >
              <p
                className={`${
                  width < 440
                    ? "text-[11px]"
                    : width < 480
                    ? "text-[12px]"
                    : "text-[14px]"
                } text-neutral-700 sm:text-lg md:text-lg font-medium `}
              >
                Practice daily to grow your streak. The more
              </p>
              <p
                className={`${
                  width < 440
                    ? "text-[11px]"
                    : width < 480
                    ? "text-[12px]"
                    : "text-[14px]"
                } text-neutral-700 sm:text-lg md:text-lg font-medium `}
              >
                consistent you are, the higher your streak
              </p>
            </ZoomInWrapper>
            <ZoomInWrapper delay={0.4}>
              <div className="flex items-center gap-3 mt-4 sm:mt-8">
                <a
                  href="https://play.google.com/store/apps/details?id=app.netpractice.app&pcampaignid=web_share"
                  target="_blank"
                  aria-label="NetPractice | Google Play"
                  className="btn"
                  title="NetPractice | Google Play"
                >
                  <Image
                    src="/assets/startPage/Frame_1_GS.svg"
                    alt="Start Icon"
                    width={180}
                    height={64}
                    sizes=""
                    // className="mr-3"
                  />
                </a>
                <a
                  href="#downloadApp"
                  aria-label="start revising"
                  className="btn"
                  title="start revising"
                >
                  <Image
                    src="/assets/startPage/Frame_1_AS.svg"
                    alt="Start Icon"
                    width={180}
                    height={64}
                    // className="mr-3"
                  />
                </a>
              </div>
            </ZoomInWrapper>
          </div>
        </div>
      ) : (
        <div className="flex item-center justify-end m-10 min-h-[70vh]  text-center w-full h-full bg-[url('/assets/joinPage/Frame_9B.webp')] bg-contain  bg-no-repeat  bg-center ">
          <div className="z-10 w-5/10  text-left flex flex-col justify-center my-6">
            <ZoomInWrapper>
              <div className="text-4xl sm:text-5xl font-extrabold  mb-1">
                Create your <span className="text-orange-500"> Personal </span>
              </div>
            </ZoomInWrapper>
            <ZoomInWrapper delay={0.2}>
              <div className="text-4xl sm:text-5xl font-extrabold mb-4">
                <span className="text-orange-500"> Revisions </span> Today
              </div>
            </ZoomInWrapper>
            <ZoomInWrapper delay={0.3}>
              <p className="text-neutral-700 text-md font-medium">
                Practice daily to grow your streak. The more
              </p>
              <p className="text-neutral-700 text-md font-medium">
                consistent you are, the higher your streak
              </p>
            </ZoomInWrapper>
            <ZoomInWrapper delay={0.4}>
              <div className="flex items-center gap-3 mt-5">
                 <a
                  href="https://play.google.com/store/apps/details?id=app.netpractice.app&pcampaignid=web_share"
                  target="_blank"
                  aria-label="NetPractice | Google Play"
                  className="btn"
                  title="NetPractice | Google Play"
                >
                  <Image
                    src="/assets/startPage/Frame_1_GS.svg"
                    alt="Start Icon"
                    width={264}
                    height={64}
                    // className="mr-3"
                  />
                </a>
                <a
                  href="#downloadApp"
                  aria-label="start revising"
                  className="btn"
                  title="start revising"
                >
                  <Image
                    src="/assets/startPage/Frame_1_AS.svg"
                    alt="Start Icon"
                    width={264}
                    height={64}
                    // className="mr-3"
                  />
                </a>
              </div>
            </ZoomInWrapper>
          </div>
        </div>
      )}
    </section>
  );
};

export default JoinSection;
